import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import PayPage from "./pages/PayPage";
import PaySuccessPage from "./pages/PaySuccessPage";

function App() {
  return (
    <div className="App bg-[#0A0A0A] text-white min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/paiement/:slug" element={<PayPage />} />
          <Route path="/paiement/:slug/succes" element={<PaySuccessPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#121214",
            border: "1px solid rgba(176,38,255,0.4)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

export default App;
